import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  phoneNumber: string(),
  typeId: string().nullable(),
});

export default yupResolver(validationSchema);
